import React from 'react'

import _modules from '../../_modules'

const Job = React.lazy(() => import('./views/job/Job'))
const JobDetail = React.lazy(() => import('./views/job/JobDetail'))

const JobCategory = React.lazy(() => import('./views/jobCategory/JobCategory'))
const JobCategoryDetail = React.lazy(() => import('./views/jobCategory/JobCategoryDetail'))

const jobProgress = React.lazy(() => import('./views/jobProgress/jobProgress'))
const jobProgressDetail = React.lazy(() => import('./views/jobProgress/jobProgressDetail'))

const JobChart = React.lazy(() => import('./views/jobChart/JobChart'))

const _routes = []

if (_modules.projects) {
  _routes.push(
    ...[
      {
        path: '/Job/:id',
        name: 'Job Detail',
        component: JobDetail,
      },
      { path: '/job', name: 'Projects', component: Job },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/job-category/:id',
        name: 'Job Category Detail',
        component: JobCategoryDetail,
      },
      { path: '/job-category', name: 'Job Category', component: JobCategory },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/job-progress/:id',
        name: 'Job Progress Detail',
        component: jobProgressDetail,
      },
      { path: '/job-progress', name: 'Job Progress Detail', component: jobProgress },
    ],
  )

  _routes.push(...[{ path: '/job-chart', name: 'Job Chart', component: JobChart }])
}

export default _routes
